<template>
    <h2 class="my-text-black" style="text-align: center;">Estadísticas prestacional</h2>
    <v-data-iterator :items="estadisticas">
        <template v-slot:default="{ items }">
            <template
            v-for="(item, i) in items"
            :key="i"
            >
                <v-card-item v-if="item.raw.tipoEstadistica == 'Torta'">
                    <v-card-title class="my-text-black">
                        {{ item.raw.nombre }} - (Total: {{ item.raw.datos.reduce((total, elemento) => total + elemento.valor, 0) }})
                    </v-card-title>
                    <v-card-text class="my-text-black">
                        <div>
                            <PieChart 
                                :data="getChartData(item, true)" 
                                :options="chartOptionsPie" />
                        </div>
                    </v-card-text>
                </v-card-item>
                <v-card-item v-if="item.raw.tipoEstadistica == 'Barra'">
                    <v-card-title class="my-text-black">
                        {{ item.raw.nombre }} - (Total: {{ item.raw.datos.reduce((total, elemento) => total + elemento.valor, 0) }})
                    </v-card-title>
                    <v-card-text class="my-text-black">
                        <div>
                            <BarChart 
                                :data="getChartData(item, false)"
                                :options="chartOptionsBar" />
                        </div>
                    </v-card-text>
                </v-card-item>

                <br>
            </template>
        </template>
    </v-data-iterator>
</template>

<style src="../assets/general.css"></style>

<script>
/* eslint-disable */
    import EstadisticasService from '@/api/EstadisticasService';
    import { Pie , Bar} from 'vue-chartjs';
    import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, BarElement, CategoryScale, LinearScale} from 'chart.js';

    const estadisticasService = new EstadisticasService();

    ChartJS.register(Title, Tooltip, Legend, ArcElement);
    ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

    export default{
        name: 'Estadisticas',
        components: {
            PieChart: Pie,
            BarChart: Bar
        },
        data(){
            return{
                estadisticas: [],
                intervalId: null,
                cargandoEstadisticas:false,
                chartOptionsPie: {
                    responsive: true,
                    maintainAspectRatio: false,
                },
                chartOptionsBar: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        y: {
                            beginAtZero: true
                        }
                    }
                }
            }
        },
        mounted(){
            this.intervalId = setInterval(async () => {   
                await this.loadEstadisticas();
            }, 60 * 1000);

            this.loadEstadisticas();
        },
        beforeUnmount() {
            if (this.intervalId) {
                clearInterval(this.intervalId);
            }
        },
        methods:{
            async loadEstadisticas(){
                if (this.cargandoEstadisticas) return;
            
                try {
                    this.cargandoEstadisticas = true;
                    
                    const response = await estadisticasService.getEstadisticas();
                    if (response) {
                        this.estadisticas = response;
                    }
                } catch (error) {
                    console.error("Error al cargar estadísticas:", error);
                } finally {
                    this.cargandoEstadisticas = false;
                }
            },
            getChartData(item, girarColor) {
                const predefinedColors = [
                    'rgb(87, 160, 103)',   // Verde
                    'rgb(205, 73, 73)',   // Rojo
                    'rgb(87, 118, 160)',   // Azul
                    'rgb(153, 102, 255)',  // Púrpura
                    'rgb(255, 159, 64)',   // Naranja
                    'rgb(255, 206, 86)',   // Amarillo
                ];
                let datos = item.raw.datos.map(element => element.valor);

                return {
                    labels: item.raw.datos.map(element => element.clave),
                    datasets: [{
                        label: item.raw.label,
                        data: datos,
                        backgroundColor: girarColor ? datos.map((_, i) => predefinedColors[i % predefinedColors.length]) : 'rgb(205, 73, 73)'
                        //Voy rotando los colores si girarColor es true
                    }]
                };
            },
        }
    };
</script>